import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "../../../../form/src/common/components/system-control/pc/index.vue";
import mobile from "../../../../form/src/common/components/system-control/mobile/index.vue";
const info = {
    title: "修改人",
    title_i18n: "{\"zh\": \"修改人\", \"en\": \"ModifyBy\"}",
    type: "modifier",
    icon: "h-icon-all-user-modifier-o",
    dataItemType: DataItemType.StaffSingle,
    formControllerType: FormControlType.ModifyBy,
    group: "系统控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
